import dayjs from 'dayjs'
import { PlatePage_CulturePlate } from '~/api/backend/pages/platePageAPI'
import MetadataSidebar, { MetadataItem } from '~/components/MetadataSidebar'
import cs from './plate_metadata_sidebar.scss'

export default function PlateMetadataSidebar({
  plate,
}: {
  plate: PlatePage_CulturePlate
}) {
  const firstCheckedInAt = dayjs(plate.firstCheckedInAt)
  const firstCheckedInThisYear = firstCheckedInAt.year() === dayjs().year()

  return (
    <MetadataSidebar>
      <MetadataItem label='First Checked In'>
        {firstCheckedInAt.format(firstCheckedInThisYear ? 'MMM D' : 'MMM D, YYYY')}
        &ensp;
        {firstCheckedInAt.format('h:mm A')}&ensp;
        <span className={cs.secondary}>({firstCheckedInAt.fromNow()})</span>
      </MetadataItem>

      <MetadataItem label='Barcode'>{plate.barcode}</MetadataItem>
    </MetadataSidebar>
  )
}
